const headersTitles = [
    "Cuota Nro.",
    "Fecha a Pagar",
    "Monto a Pagar($)",
    "Monto Pagado($)",
    "Fecha de Pago",
    "Saldo por Pagar",
    "Estado",    
    "Acciones"
];

module.exports = {
    headersTitles
};



// WEBPACK FOOTER //
// ./src/views/PaymentPlan/PaymentPlanVariables.js